import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { generateUnifiedInvoiceHTML } from '../../utils/unifiedInvoiceTemplate';

const InvoiceDetails = () => {
  const { id } = useParams();
  const previewRef = useRef(null);

  // Sample invoice data - replace with actual API call
  const invoice = {
    company: { 
      name: 'TFS TRADERS', 
      address: 'shop no.1 achinera road Brij nagar BHARATPUR, bharatpur, Rajasthan, 321001', 
      mobile: '9414419941', 
      gstin: '08ARQPT1298L1ZS', 
      email: 'tfstraders2021@gmail.com',
      logo: null
    },
    billTo: { 
      name: 'Yaspal Ji Raj Hotels Saras', 
      address: 'saras choraha bharatpur Rajasthan, bharatpur', 
      mobile: '9829721802', 
      state: 'Rajasthan' 
    },
    shipTo: { 
      name: 'Yaspal Ji Raj Hotels Saras', 
      address: 'saras choraha bharatpur Rajasthan, bharatpur',
      mobile: '9829721802'
    },
    items: [
      {
        description: 'GLS191SKVASF',
        serialNumber: 'S.No-CUT+ AB70DG0KQT6/K68',
        quantity: 1,
        rate: 30468.75,
        tax: 28,
        amount: 30468.75,
        hsn: 'HSN001'
      }
    ],
    subtotal: 30468.75,
    totalAmount: 39000,
    taxableAmount: 30468.75,
    cgst: 4265.63,
    sgst: 4265.63,
    amountInWords: 'Thirty Nine Thousand Rupees',
    bankDetails: {
      name: 'TFS TRADERS',
      ifsc: 'HDFC0008352',
      accountNo: '50200080364460',
      bank: 'HDFC Bank BHARATPUR IV'
    },
    terms: 'use of items not return, only repair in warrenty period as company proposed',
    invoiceNumber: 'TS/SL/24-25/191',
    invoiceDate: '04/05/2025',
    documentType: 'invoice'
  };

  useEffect(() => {
    if (previewRef.current) {
      const htmlContent = generateUnifiedInvoiceHTML(invoice);
      previewRef.current.innerHTML = htmlContent;
    }
  }, [invoice]);

  return (
    <div className="invoice-details-page">
      <div className="page-header">
        <h1>Invoice Details</h1>
        <p>Invoice #{invoice.invoiceNumber}</p>
      </div>

      <div className="invoice-preview" style={{
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: '20px'
      }}>
        <div 
          ref={previewRef}
          style={{ 
            width: '100%', 
            maxWidth: '210mm', /* A4 width */
            minHeight: '800px',
            overflow: 'hidden',
            margin: '0 auto'
          }}
        />
      </div>
    </div>
  );
};

export default InvoiceDetails; 